import type { FC } from "react";

import styles from "./VacancyTabs.module.scss";
import { CareerBackInterfacesDTOVacancyExpandVacancyDto } from "../../../../shared/ApiContract/data-contracts";
import { classNames } from "../../../../shared/lib/classNames";

type iconSize = "small" | "medium";

interface VacancyTabsProps {
    vacancy: CareerBackInterfacesDTOVacancyExpandVacancyDto | null | undefined;
    className?: string;
    iconSize?: iconSize;
    isVisible?: boolean;
}

export const VacancyTabs: FC<VacancyTabsProps> = ({ vacancy, className, iconSize = "small", isVisible = false }) => {
    return (
        <div
            className={classNames({
                cls: styles.tabsWrapper,
                mods: { [styles["mobileTabs"]]: isVisible },
                additional: [className],
            })}
        >
            {vacancy?.salary && (
                <p
                    className={classNames({
                        cls: styles.salary,
                        mods: { [styles[iconSize]]: iconSize },
                    })}
                >
                    {vacancy.salary} ₽
                </p>
            )}
            {vacancy?.jobExperience && (
                <p
                    className={classNames({
                        cls: styles.experience,
                        mods: { [styles[iconSize]]: iconSize },
                    })}
                >
                    {vacancy.jobExperience}
                </p>
            )}
            {vacancy?.employmentType && (
                <p
                    className={classNames({
                        cls: styles.employment,
                        mods: { [styles[iconSize]]: iconSize },
                    })}
                >
                    {vacancy.employmentType}<br/>
                    {vacancy.workSchedule}
                </p>
            )}
            {vacancy?.city && (
                <p
                    className={classNames({
                        cls: styles.city,
                        mods: { [styles[iconSize]]: iconSize },
                    })}
                >
                    {vacancy.city}
                </p>
            )}
        </div>
    );
};
